import { ReactComponent as IconClose } from "@/assets/svgs/icon-close.svg";
import Button from "@/components/Button/index";
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import rem from "@/utils/rem";

export const ResetNotificationModal = ({
	isModalVisible,
	hideModal,
	confirmCallback,
}) => {
	const handleSubmitBtnClicked = async () => {
		hideModal();
		confirmCallback();
	};

	return (
		<Modal visible={isModalVisible} variant="medium"  close={hideModal}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Reset to default
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						Do you want to reset all notifications to default
						settings?
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button data-testid="cancel-btn" ghost text="Cancel" submit={hideModal} />
						<span
							style={{ width: rem(10), display: "inline-block" }}
						></span>
						<Button
							data-testid="reset-btn"
							warning
							style={{ background: "#A72E12" }}
							text="Reset"
							submit={handleSubmitBtnClicked}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	);
};
